import React, { Fragment, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-apollo';
import { useHistory, useRouteMatch } from 'react-router-dom';

import useAuthenticated from '../../../hooks/useAuthenticated';
import FullScreenLoader from '../../../components/global/FullScreenLoader';
import { AlbumFolderForSpecialtyAlbumInvites } from '../../../graphql/queries/album-folder';
import AutoContributorLinkHandlerHeadMeta from '../../../apps/pro/views/AutoContributorLinkHandler/AutoContributorLinkHandlerHeadMeta';
import ErrorView from '../../../components/global/ErrorView';
import { autoContributorJoin as autoContributorJoinMutation } from '../../../graphql/mutations/contributors';
import { getErrorString } from '../../../util/normalize-errors';

const SpecialtyEventJoinView = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const authenticated = useAuthenticated();
  const [error, setError] = useState('');
  const { data: { albumFolder, loading } = {} } = useQuery(
    AlbumFolderForSpecialtyAlbumInvites,
    {
      variables: {
        id: match?.params?.albumFolderId,
      },
      skip: !match?.params?.albumFolderId,
    },
  );

  const [autoContributorJoin] = useMutation(autoContributorJoinMutation);

  const autoContribute = async () => {
    try {
      await autoContributorJoin({
        variables: { input: { id: albumFolder.id } },
      });
      history.push(`/app/shutterbug/folders/${albumFolder.id}`);
    } catch (e) {
      setError(getErrorString(e));
    }
  };

  useEffect(() => {
    if (authenticated && albumFolder) {
      autoContribute();
    }
  }, [albumFolder]);

  if (!authenticated) {
    return (
      <ErrorView
        location={{
          state: {
            error: "You don't have privileges to perform this action.",
          },
        }}
      />
    );
  }

  if (error) {
    return (
      <ErrorView
        location={{
          state: {
            error,
          },
        }}
      />
    );
  }

  if (!loading && !albumFolder) {
    return (
      <ErrorView
        location={{
          state: {
            error:
              'It looks like the link provided does not match any of our records.',
          },
        }}
      />
    );
  }

  return (
    <Fragment>
      <AutoContributorLinkHandlerHeadMeta entity={albumFolder} />
      <FullScreenLoader />
    </Fragment>
  );
};

export default SpecialtyEventJoinView;
